export type ProfileSortKey =
  | 'email'
  | 'nom'
  | 'prenom'
  | 'created_at'
  | 'last_sign_in_at'
  | 'role';

export type SortDir = 'asc' | 'desc';

export type SortState = {
  key: ProfileSortKey;
  dir: SortDir;
};

function textValue(v: unknown): string {
  return String(v ?? '').trim().toLocaleLowerCase('fr');
}

function dateValue(v: unknown): number {
  if (!v) return 0;
  const t = new Date(String(v)).getTime();
  return Number.isFinite(t) ? t : 0;
}

export function compareBySortKey<T extends Record<string, unknown>>(
  a: T,
  b: T,
  key: ProfileSortKey,
  dir: SortDir,
): number {
  let cmp = 0;
  if (key === 'created_at' || key === 'last_sign_in_at') {
    cmp = dateValue(a[key]) - dateValue(b[key]);
  } else {
    cmp = textValue(a[key]).localeCompare(textValue(b[key]), 'fr', { sensitivity: 'base' });
  }
  return dir === 'asc' ? cmp : -cmp;
}

export function sortProfiles<T extends Record<string, unknown>>(
  rows: T[],
  sort: SortState,
): T[] {
  return [...rows].sort((a, b) => compareBySortKey(a, b, sort.key, sort.dir));
}

/** Premier clic : dates en desc, textes en asc ; reclic inverse le sens. */
export function nextSortState(current: SortState, clicked: ProfileSortKey): SortState {
  if (current.key === clicked) {
    return { key: clicked, dir: current.dir === 'asc' ? 'desc' : 'asc' };
  }
  const defaultDesc = clicked === 'created_at' || clicked === 'last_sign_in_at';
  return { key: clicked, dir: defaultDesc ? 'desc' : 'asc' };
}

export const DEFAULT_ADMIN_SORT: SortState = {
  key: 'created_at',
  dir: 'desc',
};
